export enum ApiRoot {
    ListOfValues_REST = 'ListOfValues_REST/GetListOfValues',
    ActivityCode_REST = "ActivityCode_REST/ActivityCode",
    DCCICPIntegration = "DCCICPIntegration",
    PLATINUM_MEMBER = "platinumMember",
    DCVenueBooking = "DCVenueBooking/VenueBookingREST",
    DCCIProfessionalLicenseDetails = "DCCIProfessionalLicenseDetails",
    DCCIGenEPay = "DCCIGenEPay",
    scim2 = "scim2",
    JUPITER_REST = "Jupiter_Rest/JupiterAttachmentProxyREST",
    ATTESTATION_DCCICREATESVS = "DCCICreateSVS/SVSProxyService_rest",
    ATA_DC_SERVICE_REQUEST_INTEGRATION_API = "DCServiceRequestIntegrationAPI/ServiceRequestIntegrationAPI_RESTProxy",
    DC_CASE_INTEGRATION_API = "DCCaseIntegrationAPI/CaseIntegrationAPI_RESTProxy",
    ICA_PERSON_INQUIRY = "DCCICPIntegration/ICAPersonalInquiry",
    LIFERAY_TOKEN_REST = "LiferayToken/LiferayREST",
    INVOICE_OCR_SERVICE = "InvoiceOCRService",
    SERVICE_REQUEST_INTEGRATION_API_REST = "DCServiceRequestIntegrationAPI/ServiceRequestIntegrationAPI_REST"
}
export enum ApiEndPoints {
    LOOKUP_URL = 'ListOfValues_REST/GetListOfValues',
    ACTIVITIES = "ActivityCode_REST/ActivityCode",
    GET_USER_PROFILE = "GetUserProfileDetailsREST/GetUserProfileDetails", //"RunSiebelProcessRest/RunSiebelProcess", 
    GET_USER_PROFILE_RUN_PROCESS = "RunSiebelProcessRest/RunSiebelProcess", //"RunSiebelProcessRest/RunSiebelProcess", 
    VALIDATE_MEMBER_LICENSE = "ValidateAccount_REST/ValidateAccount",
    GET_SR_SUMMARY = "SRSummary_REST/GetSRSummary",
    GET_MEMBER_DATA = "MemberDataToSiebel_REST/memberdata",
    GET_SR_DETAIL = "RunSiebelProcessRest/RunSiebelProcess",
    ePAY_GENERATE = "ePayGenerate_Rest/ePayGenerate",
    UPDATE_PROFILE = "Me",
    CREATE_UPDATE_SR = "RunSiebelProcessRest/RunSiebelProcess",
    VERIFY_SIGNATURE = "VerifySignature/VerifySignature",
    AUTHENTICATE_CERTIFICATE = "AuthenticateCertificate_REST/AuthenticateCertificate",
    GET_SR_SERVICE_FEES = "GetSrServiceFeesREST_ProxyService/GetSrServiceFees",
    GET_CURRENCY_LIST = "GetCurrencyListREST_ProxyService/GetCurrencyList",
    GET_DC_ALL_MEMBERS = "RunSiebelProcessRest/RunSiebelProcess",
    DOCUMENT_OPEN_FOLDER = "open",
    DOCUMENT_GET_TYPES = "document-types",
    UPLOAD_DOCUMENT = "upload",
    DELETE_DOCUMENT = "delete",
    DELETE_BULK_DOCUMENT = "bulk-delete",
    ATTESTATION_CREATE_UPDATE_SR_AUTH_CERTIFICATE = "AuthCert",
    ATTESTATION_CREATE_UPDATE_SR_SIGNATURE = "Signature",
    ATTESTATION_CREATE_UPDATE_SR_CERTIFY_DOCUMENT = "TrueCopy",
    ATTESTATION_GET_SR_DETAIL = "QuerySVS",
    GET_COO_LIST = "GetCOOList_RESTProxyService/GetCooList",
    GET_ALL_PAYLIST = "GetAllPayList_RESTProxy/GetAllPayList",
    ATA_MANAGE_SERVICE_REQUEST = "manageServiceRequest",
    ATA_QUERY_SERVICEREQUEST = "queryServiceRequest",
    QUERY_CASE = "queryCase",
    MANAGE_CASE = "manageCase",
    DCCI_NOTES = "DCCINotesRest/notes",
    RUN_PROCESS = "RunSiebelProcessRest/RunSiebelProcess",
    GET_HS_CODE = "HsCodeList_RESTProxy/GetHsCodeList",
    CREATE_TOPUP_SR = "CreatePaymentTopupSR_RESTProxy/CreateTopupSR",
    GET_ATA_CARNET_DETAILS = "getATACarnetDetails",
    VALIDATE_COO_INVOICE_NUMBER = "ValidateCOOInv_RESTProxyService/ValidateCOOInvoiceNumber",
    CREATE_COO = "COO_REST/CreateCOO",
    QUERY_COO = "QueryCOO_RESTProxy/QueryCOO",
    GET_MEMBER_DETAIL_BY_CSN = "RunSiebelProcessRest/RunSiebelProcess",
    COO_GET_EXPORTER = "GetExpoterList_RESTProxy/getExpoterList",
    COO_GET_COSIGNEE_LIST = "GetCosigneeList_RESTProxy/getCosigneeList",
    GET_PERSON_INQUIRY = "GetPersonInquiry",
    GET_UPLOAD_DOC = "UploadDocRest/uploadDocument",
    PRINT_PREVIEW = "PrintPriviewRest/printPreview",
    GET_COMMERCIAL_DIRECTORY = "ComercialDirectoryRest/getCommercialDirectory",
    QUERY_PACKAGE_QUARTER = "queryPackageQuarter",
    CREATE_CONTACT_US_LOGS = "CreateContactUsLogs_REST/CreateContactUsLogs",
    GET_SERVICE_COUNT_REST = "GetServiceCountAPI_REST/GetServiceCountAPI",
    GET_STATUS_COUNT_REST = "GetServiceCountAPI_REST/GetServiceStatusAPI",
    QUERY_PENDING_SR_CASE_DETAILS = "querypendingSrCasedetails",
    GET_SPENDING_AMOUNT_REST = "GetServiceCountAPI_REST/GetSpendingAmountAPI",
    GET_SERVICEWISE_SPEND_AMT_REST = "GetServiceCountAPI_REST/GetServicewiseSpendAmt",
    DCE_CREATE_SR = "DCECreateSR_REST/DCECreateSR",
    VENUE_GET_MASTER_DATA = "getMasterData",
    VENUE_PAYMENT_URL_STATUS = "GenericGetAPIRest/PaymentURLStatus",
    GET_NOTIFICATION_HISTORY = "GetNotificationHistoryListREST/GetNotificationHistoryList",
    VERIFY_EMAIL_OTP = "VerifyEmailOTP_REST/VerifyEmailOTP",
    GENERATE_EMAIL_OTP = "GenerateEmailOTP_REST/GenerateEmailOTP",
    GET_SERVICETYPEWISE_COUNT_REST = "GetServiceCountAPI_REST/GetServicetypewiseCount",
    GET_MEMBER_SERVICE_COMPLETIONCOUNT = "GetServiceCountAPI_REST/GetMemberServiceCompletionCount",
    LIFERAY_TOKEN = "LiferayToken",
    CREATE_REQ = "CreateRequestID/CreateReq",
    INVOICE_PROCESSING = "InvoiceProcessingREST/InvoiceProcessing",
    PLATINUM_MEMBER_FILE_DOWNLOAD = "FileDownload",
    PLATINUM_MEMBER_EMBED_TOKEN = "EmbedToken",
    ONLINE_PAYMENT_FLAG_UPDATE = "OnlinePaymentFlagUpdate_REST/OnlinePaymentFlagUpdate",
    CHECK_OPEN_SR="CheckOpenSR"
}
